import AdminsTable from 'pages/Users/AdminsTable';

const ClientAdminsTable = ({ data, pagination }) => {
  return (
    <AdminsTable
      data={data}
      pagination={pagination}
      onPageChange={() => {}}
    ></AdminsTable>
  );
};

export default ClientAdminsTable;
